<template>
  <nav class="navbar indigo darken-4">
    <div class="nav-wrapper">
      <div class="navbar-left">
        <a href="#" @click.prevent="$emit('menulogoclick')">
          <i class="material-icons">dehaze</i>
        </a>
        <span>{{ date | dateWithWordFullFilter }}</span>
      </div>
      <div class="navbar-left shua">
        <img src="@/assets/logo.svg" />
      </div>
      <ul class="right">
        <li>
          <a
            class="dropdown-trigger"
            href="#"
            data-target="dropdown"
            ref="dropdown"
          >
            {{ userName }}
            <i class="material-icons right">arrow_drop_down</i>
          </a>

          <ul id="dropdown" class="dropdown-content">
            <li class="divider" tabindex="-1"></li>
            <li>
              <a href="#" class="black-text" @click.prevent="logout">
                <i class="material-icons">assignment_return</i>გამოსვლა
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
<style scoped>
@media only screen and (max-width: 1100px) {
  .navbar-left span {
    display: none;
  }
  .navbar-left.shua {
    display: none;
  }
}
</style>
<script>
import M from "materialize-css";
export default {
  data: () => ({
    date: new Date(),
    userName: "",
    interval: null,
    dropdown: null,
  }),
  mounted() {
    const User = JSON.parse(localStorage.getItem("User"));
    this.userName = User.fullName;
    this.interval = setInterval(() => {
      this.date = new Date();
    }, 1000);
    this.dropdown = M.Dropdown.init(this.$refs.dropdown, {
      constrainWidth: false,
    });
  },
  methods: {
    logout() {
      localStorage.removeItem("User");
      this.$router.push("/login?message=logout");
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    if (this.dropdown && this.dropdown.destroy) {
      this.dropdown.destroy();
    }
  },
};
</script>
